import React from 'react';
import { Radio } from '../../../Atoms';

const RadioQuestion = ({ value, setAnswer, options }) => {
  const onChange = ({ target: { value } }) => {
    setAnswer(value);
  };

  return (
    <div className="radio-wrapper">
      {options.map((option, index) => (
        <Radio
          key={index}
          title={option.text}
          checked={value.toString() === option.id.toString()}
          value={option.id}
          onChange={onChange}
        />
      ))}
    </div>
  );
};

export default RadioQuestion;
